import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Dropdown,
  Popover,
  OverlayTrigger,
  Modal,
  Button,
  Spinner,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { GetReportCardDetailedView } from "../../api/ReportCards";
import { isFeatureEnabled } from "../global/GlobalTools";
import PropTypes from "prop-types";

const customStyles = {
  reportCardBase: {
    backgroundColor: "#ffffff",
    padding: "40px",
    marginBottom: "20px",
  },
  reportCardBaseMovil: {
    backgroundColor: "#ffffff",
    padding: "10px",
    marginBottom: "20px",
  },
  columnClasses: {
    width: "25%",
  },
  columnPeriods: {
    width: "75%",
    overflowX: "auto",
    overflowY: "hidden",
  },
  columnScore: {
    // width: "25%",
    // minWidth: "80px",
    border: "solid 1px #e9ecef",
    borderRight: "none",
    borderLeft: "none",
  },
  columnScoreRed: {
    backgroundColor: "#FFF0F3",
    border: "solid 1px #e9ecef",
    borderRight: "none",
    borderLeft: "none",
  },
  verticalText: {
    writingMode: "vertical-rl",
    transform: "rotate(180deg)",
    textAlign: "center",
    // whiteSpace: "nowrap",
    borderRight: "solid 1px #e9ecef",
    borderTop: "solid 1px #e9ecef",
    borderBottom: "solid 1px #e9ecef",
    padding: "8px",
  },
  fillCaracter: {
    background:
      "linear-gradient(to right, black 50%, rgba(255, 255, 255, 0) 0%)",
    backgroundSize: "10px 1px" /* Ajusta el tamaño del carácter repetido */,
    backgroundRepeat: "repeat-x",
    color: "transparent" /* Hace que el texto sea invisible */,
    lineHeight: 3 /* Ajusta la altura de línea si es necesario */,
  },
  shadowRowHover: {
    boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.5)",
    "&:hover": {
      boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.5)",
    },
  },
  containerCriteria: {
    padding: 0,
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    backgroundColor: "#D6DADB",
    border: "solid 1px #e9ecef",
    textAlign: "center",
    alignItems: "center",
    display: "grid",
  },

  containerScore: {
    padding: 0,
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    border: "solid 1px #e9ecef",
    textAlign: "center",
    display: "grid",
  },
  containerAverage: {
    padding: 0,
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    border: "solid 1px #e9ecef",
    textAlign: "center",
    display: "grid",
    backgroundColor: "#FAFAFA",
  },
};

const height = window.innerHeight;
const width = window.innerWidth;

const ReportCardBreakdownComponent = (props) => {
  const [t] = useTranslation(["global", "reportCards"]);
  const [reportCardInfo, setReportCardInfo] = useState({});
  const [hasDevelopmentAreas, setHasDevelopmentAreas] = useState(false);
  const [periods, setPeriods] = useState([]);
  const [widthForPeriod, setWidthForPeriod] = useState(80); //TODO: pendiente de evaluar el minimo para etos periodos
  const [criterias, setCriterias] = useState([]);
  const [widthForCriteria, setWidthForCriteria] = useState(100); //
  const [heightForPeriod, setHeightForPeriod] = useState(68);
  const [availablePartials, setAvailablePartials] = useState(false);
  // CM-52604: controls the per-partial CF average shown in the "Prom. CF"
  // column when a specific partial is selected in the period dropdown.
  const [showCFPartialAvg, setShowCFPartialAvg] = useState(false);
  // CM-52604: controls the "Prom. CF" column (period-level CF average) and
  // the cross-CF "PROMEDIO" row.
  const [showCFPeriodAvg, setShowCFPeriodAvg] = useState(false);
  // CM-52604: controls the per-class weight "NN%" shown next to each CF class
  // name (mirrors ReportCardComponent.js / the family report card).
  const [showCFWeights, setShowCFWeights] = useState(false);
  // CM-52604 (QA punto 1): the CF-averages feature flag resolved from the
  // response. The "Prom. CF" column follows the CF grouping + this flag, not
  // the per-average sub-switches (see showCFColumn below).
  const [cfFeatureActive, setCFFeatureActive] = useState(false);
  // CM-52604 (QA punto 1): the "Prom. CF" column is visible whenever the report
  // card is grouped by development areas and the CF feature is active (switch
  // "Promediar Campos Formativos"), regardless of the "Por Parciales" /
  // "Promedio Total por Periodos" sub-switches. Those only control the
  // per-partial detail and the cross-CF "PROMEDIO" row, respectively.
  const showCFColumn = hasDevelopmentAreas && cfFeatureActive;
  const [visiblePopover, setVisiblePopover] = useState({
    show: false,
    id: null,
  });
  const [loading, setLoading] = useState(true);
  const [isLoadingScores, setIsLoadingScores] = useState(true);

  const [dinamicHeightReport, setDinamicHeighReport] = useState({
    maxHeight: height - 400 + "px",
    overflowY: "auto",
    border: "solid 1px #e9ecef",
    marginLeft: 0,
    marginRight: 0,
  });
  const [assessments, setAssessments] = useState({
    hasAssessments: false,
    assessmentsList: [],
  });

  /* States for mobile mode */
  const [periodSelected, setPeriodSelected] = useState(null);
  const [partialSelectedMovil, setPartialSelectedMovil] = useState("all");
  const [showModalComments, setShowModalComments] = useState(false);
  /* States for mobile mode */

  useEffect(() => {
    getReportCard();
  }, []);

  // monitorear el ancho de pantalla con useEffect
  useEffect(() => {
    const observerResize = () => {
      handleResize();
      let dinamicHeight = { ...dinamicHeightReport };
      dinamicHeight.maxHeight = window.innerHeight - 400 + "px";
      setDinamicHeighReport(dinamicHeight);
    };
    handleResize();
    window.addEventListener("resize", observerResize);
    return () => {
      window.removeEventListener("resize", observerResize);
    };
    // CM-52604: the CF flags change the sub-column count per period, so the
    // widths must be recomputed when they resolve after the fetch.
  }, [
    periods,
    criterias,
    showCFPartialAvg,
    showCFPeriodAvg,
    hasDevelopmentAreas,
    cfFeatureActive,
  ]);

  const handleResize = () => {
    const minWidth = 104;
    const widthScore = 100;
    const containerPeriods =
      width <= 767
        ? document.getElementById("containerPeriodsMovil")
        : document.getElementById("containerPeriods");
    if (!containerPeriods) {
      setTimeout(() => {
        handleResize();
      }, 500);
      return;
    }
    const containerPeriodsWidth = containerPeriods.offsetWidth - widthScore;

    const widthPeriod = containerPeriodsWidth / periods.length;
    let newSizePeriod = widthPeriod > minWidth ? widthPeriod : minWidth;
    if (width <= 767) {
      newSizePeriod = document.getElementById(
        "containerPeriodsMovil"
      ).offsetWidth;
    }

    let minWidthCriteria = 60; //valor minimo soportado para cada criterio
    let widthCriteriaInitial = 60;

    // CM-52604: each period gains one sub-column ("Prom. CF") when the CF
    // averages are active, so the criteria width divides by one more item.
    const extraCFColumn = showCFColumn ? 1 : 0;
    if (periods.length > 0) {
      const criteriaList = periods[0].grading_criteria;
      const totalItelms = criteriaList.length + 2 + extraCFColumn;
      widthCriteriaInitial = (newSizePeriod - 2) / totalItelms;
    }

    if (widthCriteriaInitial < minWidthCriteria) {
      const totalItelms = criterias.length + 2 + extraCFColumn;

      newSizePeriod = minWidthCriteria * totalItelms;
      widthCriteriaInitial = minWidthCriteria - 1;
    }

    // algun periodo tiene parciales?
    const hasPartials = periods.some((period) =>
      period.grading_criteria.some((criteria) => criteria.partials.length > 0)
    );
    if (hasPartials && !(width <= 767)) {
      setHeightForPeriod(99);
    } else if (width <= 767) {
      const periodWithPartial = periodSelected?.grading_criteria.some(
        (criteria) => criteria.partials.length > 0
      );
      setHeightForPeriod(periodWithPartial ? 93 : 68);
    }
    setWidthForPeriod(newSizePeriod);
    setWidthForCriteria(widthCriteriaInitial);
    setTimeout(() => {
      setIsLoadingScores(false);
    }, 500);
    return;
  };

  const popoverComment = (comment) => {
    return (
      <Popover id="scoreComment">
        <Popover.Header>{reportCardInfo.student_name}</Popover.Header>
        <Popover.Body>{comment}</Popover.Body>
      </Popover>
    );
  };

  /**
   * Function to manage the click on the popover
   * @param {bool} show
   * @param {int} id
   * @returns
   */
  const handlePopoverClick = (show, id) => {
    if (!show) {
      if (visiblePopover.show && visiblePopover.id != id) {
        return;
      }
    }
    let popover = { ...visiblePopover };
    popover.show = show;
    popover.id = id;
    if (width <= 767) {
      setShowModalComments(show);
    } else {
      setVisiblePopover(popover);
    }
  };

  const getReportCard = () => {
    const payload = {
      student_id: props.studentId,
      organization_school_level_cycle_id: props.schoolLevelCycleId,
    };
    GetReportCardDetailedView(payload)
      .then((response) => {
        if (response.status) {
          let data = response.data;
          // remover los elementos que sean de tipo class y su propiedad belongs_class sea 0

          // agregar propiedad parcial seleccionado a todas las clases que tengan parciales
          data.elements.forEach((element) => {
            if (element.type === "class") {
              if (element.belongs_class === 0) {
                element.remove = true;
                return;
              }
              element.periods.forEach((period) => {
                period.selectedPartial = "all"; //criteria.partials[0];
              });
            } else if (element.type === "development_area") {
              element.classes.forEach((classElement) => {
                if (classElement.belongs_class === 0) {
                  classElement.remove = true;
                  return;
                }
                classElement.periods.forEach((period) => {
                  period.selectedPartial = "all";
                });
              });
            }
          });
          // remover las clases de los elements y dentro de los development_area que tengan remove
          data.elements.forEach((element) => {
            if (element.type === "development_area") {
              element.classes = element.classes.filter(
                (classElement) => !classElement.remove
              );
            }
          });
          data.elements = data.elements.filter((element) => !element.remove);

          // CM-52604: flags that control the "Prom. CF" column and the
          // cross-CF "PROMEDIO" row in the weighted view. Come from the
          // endpoint at the top level of the response (value 0 or 1),
          // mirroring what /v2/report_cards/view already defines.
          const cfAveragesFeature = isFeatureEnabled(
            "partial_averages_in_development_areas"
          );
          setShowCFPartialAvg(
            data.show_cf_partial_avg == 1 && cfAveragesFeature
          );
          setShowCFPeriodAvg(data.show_cf_period_avg == 1 && cfAveragesFeature);
          // CM-52604 (QA punto 1): the "Prom. CF" column is gated on the CF
          // grouping + this feature flag, decoupled from the sub-switches.
          setCFFeatureActive(cfAveragesFeature);
          // CM-52604: gate the per-class weight "%" the same way /view does
          // (endpoint flag show_cf_weights + the same feature flag), so both
          // report cards show it under identical conditions.
          setShowCFWeights(data.show_cf_weights == 1 && cfAveragesFeature);

          setReportCardInfo(data);
          //buscar un elemento de tipo area de desarrollo
          const developmentAreaElement = data.elements.find(
            (element) => element.type === "development_area"
          );
          if (developmentAreaElement) setHasDevelopmentAreas(true);
          const classElement = data.elements.find(
            (element) => element.type === "class"
          );
          //obtener los peridos de la claseElement
          let periodsClass = [];
          if (classElement) {
            periodsClass = classElement.periods;
          } else {
            //obtener los peridos de la claseElement
            if (developmentAreaElement) {
              periodsClass = developmentAreaElement.classes[0].periods;
            }
          }
          periodsClass.forEach((period, index) => {
            period.position = index + 1;
          });
          setPeriods(periodsClass);
          setPeriodSelected(periodsClass[0]);
          // obtener los criterios
          const criteriaList = periodsClass[0].grading_criteria;

          setCriterias(criteriaList);
          // setWidthForCriteria(100 / periodsClass.length);

          // verificar si al menos un criterio tiene parciales
          let hasPartials = periodsClass.some((period) =>
            period.grading_criteria.some(
              (criteria) => criteria.partials.length > 0
            )
          );
          if (width <= 767) {
            hasPartials = periodsClass[0].grading_criteria.some(
              (criteria) => criteria.partials.length > 0
            );
          }
          setAvailablePartials(hasPartials);
          // buscar si el nivel tiene examenes finales (assessments)
          searchFinalExams(data);
        }
      })
      .finally(() => {
        setLoading(false);
        handleResize();
      });
  };

  const searchFinalExams = (data) => {
    let assessments = [];
    //buscar una clase en elementos
    const classElement = data.elements.find(
      (element) => element.type === "class"
    );
    if (!classElement) {
      //buscar un area de desarrollo en elementos
      const developmentAreaElement = data.elements.find(
        (element) => element.type === "development_area"
      );
      //tomar la primera clase del area de desarrollo
      assessments = developmentAreaElement.classes[0].assessments || [];
    } else {
      assessments = classElement.assessments || [];
    }
    if (assessments.length > 0) {
      setAssessments(
        Object.assign({}, assessments, {
          hasAssessments: true,
          assessmentsList: assessments,
        })
      );
    }
  };

  const handlePartialChange = (periodId, partial) => {
    let periodsCopy = [...periods];
    periodsCopy.forEach((period) => {
      if (period.id == periodId) {
        period.selectedPartial = partial;
      }
      if (partial.id == "all") {
        period.selectedPartial = "all";
      }
    });
    setPeriods(periodsCopy);
  };

  const scoreByFilters = (period, criteria, movilView = false) => {
    const copyPeriods = [...periods];
    if (copyPeriods.length === 0) return 0;

    let partialSelected = copyPeriods.find(
      (periodItem) => periodItem.id == period.id
    ).selectedPartial;

    if (movilView) {
      partialSelected = partialSelectedMovil;
    }
    if (partialSelected === "all") {
      const criteriaFocus = period.grading_criteria.find(
        (criteriaItem) => criteriaItem.id == criteria.id
      );
      return criteriaFocus.score;
    } else {
      const criteriaFocus = period.grading_criteria.find(
        (criteriaItem) => criteriaItem.id == criteria.id
      );
      const partialFocus = criteriaFocus.partials.find(
        (partial) => partial.id == partialSelected.id
      );
      return partialFocus.score;
    }
  };

  // CM-52604: resolves the value shown in the "Prom. CF" column for one
  // period, honoring the partial selected in the period dropdown: "all" →
  // CF period average; a specific partial → CF partial average
  // (show_cf_partial_avg). Returns "-" when the matching flag is off or the
  // value is missing.
  const cfAverageByFilters = (cfPeriod, periodId) => {
    if (!cfPeriod) return "-";
    const statePeriod = periods.find((periodItem) => periodItem.id == periodId);
    const partialSelected = statePeriod ? statePeriod.selectedPartial : "all";
    if (partialSelected === "all" || !partialSelected) {
      // CM-52604 (QA punto 1): the per-CF period average shows whenever the
      // "Prom. CF" column is visible (CF grouping + feature flag), decoupled
      // from the "Por Parciales" / "Promedio Total por Periodos" sub-switches.
      // The cross-CF "PROMEDIO" row's visibility is gated separately on
      // showCFPeriodAvg.
      return showCFColumn ? cfPeriod.average || "-" : "-";
    }
    if (!showCFPartialAvg) return "-";
    const partialAverage = (cfPeriod.partials_average || []).find(
      (partialItem) => partialItem.id == partialSelected.id
    );
    return (partialAverage && partialAverage.average) || "-";
  };

  // calificaiones vista movil
  const headerPeriodForMovilView = () => {
    return (
      <div
        style={{
          ...customStyles.columnPeriods,
          width: "60%",
          // padding: 0,
          overflowX: "clip",
          // paddingLeft: 0,
        }}
        id="containerPeriodsMovil"
      >
        {/* periods */}
        <Row
          style={{
            height: "30px",
            textAlign: "center",
            alignItems: "center",
            borderBottom: "solid 1px #e9ecef",
          }}
        >
          <Dropdown className="noCaretDd" style={{ padding: 0 }}>
            <Dropdown.Toggle
              id="dropdownReportCards"
              variant="outline-secondary"
              style={{
                width: "inherit",
                border: "none",
                boxShadow: "none",
                borderRadius: "0",
              }}
            >
              {periodSelected === "assessments"
                ? t("reportCards:reportCardBreakdown.finalExam")
                : t("reportCards:reportCardBasic.period") +
                  " " +
                  periodSelected.position}
              <span>
                <i
                  className="bi bi-chevron-down "
                  style={{ marginLeft: "5px" }}
                />
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu
              style={{
                width:
                  document.getElementById("dropdownReportCards")?.offsetWidth +
                  "px",
                borderRadius: "0",
              }}
            >
              {periods.map((period, index) => {
                return (
                  <Dropdown.Item
                    key={index}
                    onClick={() => {
                      const hasPartials = period.grading_criteria.some(
                        (criteria) => criteria.partials.length > 0
                      );
                      setPartialSelectedMovil("all");
                      setHeightForPeriod(hasPartials ? 93 : 68);
                      setAvailablePartials(hasPartials);
                      setPeriodSelected(period);
                    }}
                  >
                    {t("reportCards:reportCardBasic.period") +
                      " " +
                      period.position}
                  </Dropdown.Item>
                );
              })}

              {assessments.hasAssessments && (
                <Dropdown.Item
                  onClick={() => {
                    setPartialSelectedMovil("all");
                    setAvailablePartials(false);
                    setHeightForPeriod(68);
                    setPeriodSelected("assessments");
                  }}
                >
                  {t("reportCards:reportCardBasic.finalExams")}
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </Row>

        {/* partials */}
        {availablePartials && (
          <Row
            style={{
              height: "30px",
              textAlign: "center",
              borderBottom: "solid 1px #e9ecef",
            }}
          >
            <Dropdown className="noCaretDd" style={{ padding: 0 }}>
              <Dropdown.Toggle
                id="dropdownReportCards"
                variant="outline-secondary"
                style={{
                  width: "inherit",
                  border: "none",
                  boxShadow: "none",
                  borderRadius: "0",
                }}
              >
                {partialSelectedMovil && partialSelectedMovil != "all"
                  ? t("reportCards:reportCardBreakdown.partial") +
                    " " +
                    partialSelectedMovil.position
                  : t("reportCards:reportCardBreakdown.allPeriods")}
                <span>
                  <i
                    className="bi bi-chevron-down"
                    style={{ marginLeft: "5px" }}
                  />
                </span>
              </Dropdown.Toggle>
              <Dropdown.Menu
                style={{
                  width:
                    document.getElementById("dropdownReportCards")
                      ?.offsetWidth + "px",
                  borderRadius: "0",
                }}
              >
                <Dropdown.Item
                  onClick={() => {
                    setPartialSelectedMovil("all");
                  }}
                >
                  {t("reportCards:reportCardBreakdown.allPeriods")}
                </Dropdown.Item>
                {periodSelected.grading_criteria[0].partials.map(
                  (partial, indexPartial) => {
                    return (
                      <Dropdown.Item
                        key={indexPartial}
                        value={partial.id}
                        onClick={() => {
                          partial.position = indexPartial + 1;
                          setPartialSelectedMovil(partial);
                          periodSelected.selectedPartial = partial;
                          setPeriodSelected(periodSelected);
                        }}
                      >
                        {t("reportCards:reportCardBreakdown.partial") +
                          " " +
                          (indexPartial + 1)}
                      </Dropdown.Item>
                    );
                  }
                )}
              </Dropdown.Menu>
            </Dropdown>
          </Row>
        )}
        {/* calificaiones */}
        <div
          id="containerCriteriasMovil"
          style={{
            overflowX: "auto",
            overflowY: "hidden",
            marginLeft: "-12px",
            width:
              document.getElementById("dropdownReportCards")?.offsetWidth +
              12 +
              "px",
          }}
        >
          {periodSelected === "assessments" ? (
            // Promedios y examenes finales
            <>
              {/* Header de examenes finales */}
              <Row
                style={{
                  height: "39px",
                  width: "max-content",
                  marginLeft: "0",
                }}
              >
                {/* promedio  header */}
                <div
                  style={{
                    backgroundColor: "rgb(214, 218, 219)",
                    border: "1px solid rgb(233, 236, 239)",
                    textAlign: "center",
                    width: 80 + "px",
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 2,
                  }}
                >
                  <b>{t("reportCards:reportCardBreakdown.averageClass")}</b>
                </div>
                {/* Mapear examenes finales */}
                {assessments.assessmentsList.map((assessment, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        backgroundColor: "rgb(214, 218, 219)",
                        border: "1px solid rgb(233, 236, 239)",
                        textAlign: "center",
                        width: 80 + "px",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 2,
                      }}
                    >
                      {t("reportCards:reportCardBreakdown.finalExam") +
                        assessments.assessmentsList.length >
                      1
                        ? index + 1
                        : ""}
                    </div>
                  );
                })}

                {/* Promedio final */}
                <div
                  style={{
                    backgroundColor: "rgb(214, 218, 219)",
                    border: "1px solid rgb(233, 236, 239)",
                    textAlign: "center",
                    width: 80 + "px",
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 2,
                  }}
                >
                  {t("reportCards:reportCardBreakdown.finalAverage")}
                </div>
              </Row>
              {reportCardInfo.elements.map((element, index) => {
                if (element.type === "class") {
                  return (
                    <Row
                      key={index}
                      style={{
                        height: "40px",
                        // paddingLeft: "11px",
                        // paddingRight: "9px",
                        width: "max-content",
                        marginLeft: "0",
                      }}
                    >
                      {/* promedio  header */}
                      <div
                        style={{
                          ...customStyles.containerAverage,
                          width: 80 + "px",
                          alignItems: "center",
                          borderTop: "none",
                          borderBottom: "solid 2px #e9ecef",
                        }}
                      >
                        {element.average}
                      </div>
                      {/* Mapear examenes finales */}
                      {assessments.assessmentsList.map(
                        (assessment, indexExam) => {
                          return (
                            <div
                              key={indexExam}
                              style={{
                                ...customStyles.containerAverage,
                                width: 80 + "px",
                                alignItems: "center",
                                borderTop: "none",
                                borderBottom: "solid 2px #e9ecef",
                              }}
                            >
                              {assessment.score || "-"}
                            </div>
                          );
                        }
                      )}

                      {/* Promedio final */}
                      <div
                        style={{
                          ...customStyles.containerAverage,
                          width: 80 + "px",
                          alignItems: "center",
                          borderTop: "none",
                          borderBottom: "solid 2px #e9ecef",
                        }}
                      >
                        {element.final_average}
                      </div>
                    </Row>
                  );
                }

                if (element.type === "development_area") {
                  const numberOfClasses = element.classes.length;
                  const space = widthForPeriod;
                  return (
                    <Row
                      key={index}
                      style={{ width: "max-content", marginLeft: "0px" }}
                    >
                      <div
                        className="px-0"
                        style={{
                          height: 40 * numberOfClasses + "px",
                          width: space + "px",
                        }}
                      >
                        {element.classes.map((singleClass, c_index) => {
                          return (
                            <Row
                              key={c_index}
                              style={{
                                height: "40px",
                                // paddingLeft: "11px",
                                // paddingRight: "9px",
                                width: "max-content",
                                marginLeft: "0",
                              }}
                            >
                              {/* promedio  header */}
                              <div
                                style={{
                                  ...customStyles.containerAverage,
                                  width: 80 + "px",
                                  alignItems: "center",
                                  borderTop: "none",
                                  borderBottom: "solid 2px #e9ecef",
                                }}
                              >
                                {singleClass.average}
                              </div>
                              {/* Mapear examenes finales */}
                              {singleClass.assessments.map(
                                (assessment, indexExam) => {
                                  return (
                                    <div
                                      key={indexExam}
                                      style={{
                                        ...customStyles.containerAverage,
                                        width: 80 + "px",
                                        alignItems: "center",
                                        borderTop: "none",
                                        borderBottom: "solid 2px #e9ecef",
                                      }}
                                    >
                                      {assessment.score || "-"}
                                    </div>
                                  );
                                }
                              )}

                              {/* Promedio final */}
                              <div
                                style={{
                                  ...customStyles.containerAverage,
                                  width: 80 + "px",
                                  alignItems: "center",
                                  borderTop: "none",
                                  borderBottom: "solid 2px #e9ecef",
                                }}
                              >
                                {singleClass.final_average}
                              </div>
                            </Row>
                          );
                        })}
                      </div>
                    </Row>
                  );
                }
                if (element.type === "average") {
                  return (
                    <Row
                      key={index}
                      style={{
                        height: "40px",
                        // paddingLeft: "11px",
                        // paddingRight: "9px",
                        width: "max-content",
                        marginLeft: "0",
                      }}
                    >
                      {/* promedio  header */}
                      <div
                        style={{
                          ...customStyles.containerAverage,
                          width: 80 + "px",
                          alignItems: "center",
                          borderTop: "none",
                          borderBottom: "solid 2px #e9ecef",
                        }}
                      >
                        {element.total_average}
                      </div>
                      {/* Mapear examenes finales */}
                      {assessments.assessmentsList.map(
                        (assessment, indexExam) => {
                          return (
                            <div
                              key={indexExam}
                              style={{
                                ...customStyles.containerAverage,
                                width: 80 + "px",
                                alignItems: "center",
                                borderTop: "none",
                                borderBottom: "solid 2px #e9ecef",
                              }}
                            ></div>
                          );
                        }
                      )}

                      {/* Promedio final */}
                      <div
                        style={{
                          ...customStyles.containerAverage,
                          width: 80 + "px",
                          alignItems: "center",
                          borderTop: "none",
                          borderBottom: "solid 2px #e9ecef",
                        }}
                      >
                        {element.final_total_average}
                      </div>
                    </Row>
                  );
                }
              })}
            </>
          ) : (
            // calificaiones de periodos y parciales
            <>
              <Row
                style={{
                  height: "38px",
                  // paddingLeft: "11px",
                  // paddingRight: "9px",
                  width: "max-content",
                  marginLeft: "0",
                }}
              >
                {periodSelected.grading_criteria.map((criteria, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        ...customStyles.containerCriteria,
                        width: widthForCriteria + "px",
                      }}
                    >
                      <b
                        style={{
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                        }}
                      >
                        {criteria.name}
                      </b>
                      {criteria.is_averageable == 1 && (
                        <b>{criteria.percentage + "%"}</b>
                      )}
                    </div>
                  );
                })}
                {/* promedio y comenarios header */}
                <div
                  style={{
                    ...customStyles.containerCriteria,
                    width: widthForCriteria + "px",
                  }}
                >
                  <b
                    style={{
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                    }}
                  >
                    {t("reportCards:reportCardBasic.average")}
                  </b>
                </div>
                <div
                  style={{
                    ...customStyles.containerCriteria,
                    width: widthForCriteria + 4 + "px",

                    borderRight: "solid 1px #D6DADB",
                  }}
                >
                  <b
                    style={{
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                    }}
                  >
                    {t("reportCards:reportCardBreakdown.comments")}
                  </b>
                </div>
              </Row>
              {/* Iterar elementos de boleta */}
              {reportCardInfo.elements.map((element, index) => {
                if (element.type === "class") {
                  // buscar en la clase el perido seleccionado
                  const periodClass = element.periods.find(
                    (period) => period.id === periodSelected.id
                  );
                  const space = widthForPeriod;
                  return (
                    <Row
                      key={index}
                      style={{ width: "max-content", marginLeft: "0px" }}
                    >
                      <div
                        className="px-0"
                        style={{
                          display: "block ruby",
                          height: "40px",
                          width: space + "px",
                        }}
                      >
                        <div
                          key={periodClass.id}
                          style={{
                            border: "solid 1px #e9ecef",
                            height: "40px",
                            width: widthForPeriod + "px",
                            maxWidth: widthForPeriod + "px",
                            borderRight: "solid 1px #e9ecef",
                            borderBottom: "solid 1px #e9ecef",
                          }}
                        >
                          <Row
                            style={{
                              height: "40px",
                              paddingLeft: "11px",
                              paddingRight: "10px",
                            }}
                          >
                            {periodClass.grading_criteria.map(
                              (criteria, index) => {
                                return (
                                  <div
                                    key={index}
                                    style={{
                                      ...customStyles.containerScore,
                                      width: widthForCriteria + "px",
                                      alignItems: "center",
                                      borderTop: "none",
                                      borderBottom: "none",
                                    }}
                                  >
                                    {scoreByFilters(
                                      periodClass,
                                      criteria,
                                      true
                                    )}
                                  </div>
                                );
                              }
                            )}

                            {/* Pomedio y comentarios valores */}
                            <div
                              style={{
                                ...customStyles.containerAverage,
                                width: widthForCriteria + "px",
                                alignItems: "center",
                                borderTop: "none",
                                borderBottom: "solid 2px #e9ecef",
                              }}
                            >
                              {periodClass.score}
                            </div>
                            <div
                              style={{
                                ...customStyles.containerScore,
                                width: widthForCriteria + "px",
                                alignItems: "center",
                                borderRight: "none",
                                borderTop: "none",
                                borderBottom: "solid 1px #e9ecef",
                              }}
                            >
                              <b
                                style={{
                                  whiteSpace: "nowrap",
                                  textOverflow: "ellipsis",
                                  overflow: "hidden",
                                }}
                              >
                                <i
                                  className="bi bi-info-circle-fill"
                                  style={{
                                    color: "#ea2c54",
                                    fontSize: "18px",
                                    opacity: periodClass.comments ? 1 : 0.5,
                                  }}
                                  onClick={() => {
                                    periodClass.comments
                                      ? setShowModalComments(
                                          periodClass.comments
                                        )
                                      : null;
                                  }}
                                />
                              </b>
                            </div>
                          </Row>
                        </div>
                      </div>
                    </Row>
                  );
                }

                if (element.type === "development_area") {
                  const numberOfClasses = element.classes.length;
                  const space = widthForPeriod;
                  return (
                    <Row
                      key={index}
                      style={{ width: "max-content", marginLeft: "0px" }}
                    >
                      <div
                        className="px-0"
                        style={{
                          height: 40 * numberOfClasses + "px",
                          width: space + "px",
                        }}
                      >
                        {element.classes.map((singleClass, c_index) => {
                          const periodClass = singleClass.periods.find(
                            (period) => period.id === periodSelected.id
                          );
                          return (
                            <Row
                              className="px-0 mx-0"
                              key={c_index}
                              style={{
                                display: "block ruby",
                                height: "40px",
                              }}
                            >
                              <div
                                key={periodClass.id}
                                className="px-0"
                                style={{
                                  maxWidth: widthForPeriod + "px",
                                  height: "40px",
                                  display: "flex",
                                  alignItems: "center",
                                  borderRight: "solid 1px #e9ecef",
                                  borderBottom: "solid 1px #e9ecef",
                                }}
                              >
                                <Row
                                  style={{
                                    height: "40px",
                                    paddingLeft: "12px",
                                    // paddingRight: "10px",
                                    // textAlign: "center",
                                    // display: "grid",
                                  }}
                                >
                                  {periodClass.grading_criteria.map(
                                    (criteria, index) => {
                                      return (
                                        <div
                                          key={index}
                                          style={{
                                            ...customStyles.containerScore,
                                            width: widthForCriteria + "px",
                                            alignItems: "center",
                                          }}
                                        >
                                          {scoreByFilters(
                                            periodClass,
                                            criteria,
                                            true
                                          )}
                                        </div>
                                      );
                                    }
                                  )}

                                  {/* Pomedio y comentarios valores */}
                                  <div
                                    style={{
                                      ...customStyles.containerAverage,
                                      width: widthForCriteria + "px",
                                      alignItems: "center",
                                    }}
                                  >
                                    {periodClass.score}
                                  </div>
                                  <div
                                    style={{
                                      ...customStyles.containerScore, //FIXME: revisar estilos para controlar bordos
                                      width: widthForCriteria + 5 + "px",
                                      alignItems: "center",
                                      // borderBottom: "solid 1px #e9ecef",
                                      borderRight: "none",
                                    }}
                                  >
                                    <b
                                      style={{
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                        overflow: "hidden",
                                      }}
                                    >
                                      <i
                                        className="bi bi-info-circle-fill"
                                        style={{
                                          color: "#ea2c54",
                                          fontSize: "18px",
                                          opacity: periodClass.comments
                                            ? 1
                                            : 0.5,
                                        }}
                                        onClick={() => {
                                          periodClass.comments
                                            ? setShowModalComments(
                                                periodClass.comments
                                              )
                                            : null;
                                        }}
                                      />
                                    </b>
                                  </div>
                                </Row>
                              </div>
                            </Row>
                          );
                        })}
                      </div>
                    </Row>
                  );
                }

                if (element.type === "average") {
                  const periodAverage = element.periods.find(
                    (period) => period.id === periodSelected.id
                  );
                  return (
                    <Row
                      key={index}
                      style={{ width: "max-content", marginLeft: "0px" }}
                    >
                      <div
                        className="ps-0"
                        style={{
                          display: "block ruby",
                          height: "40px",
                          width: widthForPeriod + "px",
                        }}
                      >
                        <div
                          key={periodAverage.id}
                          style={{
                            border: "solid 1px #e9ecef",
                            height: "40px",
                            width: widthForPeriod + "px",
                            maxWidth: widthForPeriod + "px",
                          }}
                        >
                          <Row
                            style={{
                              height: "40px",
                              paddingLeft: "11px",
                              paddingRight: "10px",
                              // textAlign: "center",
                              // display: "grid",
                            }}
                          >
                            {periodAverage.grading_criteria.map(
                              (criteria, index) => {
                                return (
                                  <div
                                    key={index}
                                    style={{
                                      ...customStyles.containerScore,
                                      width: widthForCriteria + "px",
                                      alignItems: "center",
                                      borderTop: "none",
                                      borderBottom: "none",
                                    }}
                                  >
                                    <b></b>
                                  </div>
                                );
                              }
                            )}

                            {/* Pomedio y comentarios valores */}
                            <div
                              style={{
                                ...customStyles.containerAverage,
                                width: widthForCriteria + "px",
                                alignItems: "center",
                                borderTop: "none",
                                borderBottom: "solid 2px #e9ecef",
                              }}
                            >
                              <b
                                style={{
                                  whiteSpace: "nowrap",
                                  textOverflow: "ellipsis",
                                  overflow: "hidden",
                                }}
                              >
                                {periodAverage.score}
                              </b>
                            </div>
                            <div
                              style={{
                                ...customStyles.containerScore,
                                width: widthForCriteria + "px",
                                alignItems: "center",
                                borderRight: "none",
                                borderTop: "none",
                                borderBottom: "solid 1px #e9ecef",
                              }}
                            >
                              <b
                                style={{
                                  whiteSpace: "nowrap",
                                  textOverflow: "ellipsis",
                                  overflow: "hidden",
                                }}
                              ></b>
                            </div>
                          </Row>
                        </div>
                      </div>
                      {/* TODO: revisar en las dudas que hacer con esto*/}
                      {/* <div
                    style={{
                      width: "100px",
                      height: "40px",
                      display: "grid",
                      alignItems: "center",
                      border: "solid 1px #e9ecef",
                      backgroundColor: "#FAFAFA",
                      textAlign: "center",
                    }}
                  >
                    <b> {element.total_average}</b>
                  </div> */}
                    </Row>
                  );
                }
              })}
            </>
          )}
        </div>
      </div>
    );
  };

  const assessmentsColumns = () => {
    return (
      <>
        {assessments.assessmentsList.map((assessment, index) => {
          return (
            <div
              key={index}
              style={{
                border: "solid 1px #e9ecef",
                height: availablePartials
                  ? heightForPeriod + 5 + "px"
                  : heightForPeriod - 30 + "px",
                width: "100px",
              }}
            >
              <Row style={{ height: availablePartials ? "65px" : "30px" }}>
                <b> </b>
              </Row>
              <Row
                style={{
                  height: "38px",
                  textAlign: "center",
                  alignItems: "center",
                  backgroundColor: "#D6DADB",
                  border: "solid 1px #e9ecef",
                }}
              >
                <b>
                  {t("reportCards:reportCardBreakdown.finalExam")}
                  {assessments.assessmentsList.length > 1 ? index + 1 : ""}
                </b>
              </Row>
            </div>
          );
        })}

        {/* final average */}
        <div
          style={{
            border: "solid 1px #e9ecef",
            height: availablePartials
              ? heightForPeriod + 5 + "px"
              : heightForPeriod - 30 + "px",
            width: "100px",
          }}
        >
          <Row style={{ height: availablePartials ? "65px" : "30px" }}>
            <b> </b>
          </Row>
          <Row
            style={{
              height: "38px",
              textAlign: "center",
              alignItems: "center",
              backgroundColor: "#D6DADB",
              border: "solid 1px #e9ecef",
            }}
          >
            <b>{t("reportCards:reportCardBreakdown.finalAverage")}</b>
          </Row>
        </div>
      </>
    );
  };

  // Mostrar calificacione de examen por clase
  const scoreExamForClass = (element) => {
    const numberOfClasses = element.classes.length;
    return assessments.assessmentsList.map((assessment, index) => {
      return (
        <div
          key={index}
          style={{
            width: "100px",
            height: 40 * numberOfClasses + "px",
            alignItems: "center",
            border: "solid 1px #e9ecef",
            backgroundColor: "#FAFAFA",
            textAlign: "center",
            display: "grid",
            paddingLeft: 0,
          }}
        >
          {element.classes.map((singleClass, c_index) => {
            return (
              <Row
                className="px-0 mx-0"
                key={c_index}
                style={{
                  display: "flex",
                  height: "40px",
                }}
              >
                <div
                  key={c_index}
                  style={{
                    width: "100px",
                    height: "40px",
                    alignItems: "center",
                    border: "solid 1px #e9ecef",
                    backgroundColor: "#FAFAFA",
                    textAlign: "center",
                    display: "grid",
                  }}
                >
                  {singleClass.assessments[index].score || "-"}
                </div>
              </Row>
            );
          })}
        </div>
      );
    });
  };

  // ═══════════════════════════════════════════════════════════════════════
  // CM-52604 — CF averages in the weighted view (desktop). The renderers
  // below only run when `showCFColumn` is active; with the flags off the
  // original markup in the render section is used untouched.
  // ═══════════════════════════════════════════════════════════════════════

  /**
   * Development-area block with the merged "Prom. CF" cell (CM-52604).
   * Iterates periods first (instead of class-rows first) so the CF average
   * renders as a single cell vertically spanning every class of the CF, as
   * in the prototype. Column geometry mirrors the header: per period
   * [criteria... | "Prom." | "Prom. CF" | "Obse."], each `widthForCriteria` wide.
   */
  const developmentAreaRowWithCF = (element, index) => {
    const numberOfClasses = element.classes.length;
    const numerOfperiods = element.classes[0].periods.length;
    const space = widthForPeriod * numerOfperiods;
    const blockHeight = 40 * numberOfClasses;
    const cfPeriods = element.periods || [];
    const stackedCellStyle = (c_index) => ({
      height: "40px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderBottom:
        c_index < numberOfClasses - 1 ? "solid 1px #e9ecef" : "none",
    });
    return (
      <Row key={index} style={{ width: "max-content" }}>
        <div
          className="px-0"
          style={{
            display: "flex",
            height: blockHeight + "px",
            width: space + "px",
          }}
        >
          {element.classes[0].periods.map((basePeriod, p_index) => {
            return (
              <div
                key={p_index}
                style={{
                  border: "solid 1px #e9ecef",
                  height: blockHeight + "px",
                  width: widthForPeriod + "px",
                  maxWidth: widthForPeriod + "px",
                }}
              >
                <Row
                  style={{
                    height: blockHeight + "px",
                    paddingLeft: "11px",
                    paddingRight: "10px",
                  }}
                >
                  {basePeriod.grading_criteria.map(
                    (baseCriteria, cr_index) => {
                      return (
                        <div
                          key={cr_index}
                          style={{
                            ...customStyles.containerScore,
                            width: widthForCriteria + "px",
                            display: "block",
                          }}
                        >
                          {element.classes.map((singleClass, c_index) => {
                            const classPeriod =
                              (singleClass.periods || [])[p_index] || {};
                            const classCriteria = (classPeriod.grading_criteria ||
                              [])[cr_index];
                            return (
                              <div key={c_index} style={stackedCellStyle(c_index)}>
                                {classCriteria
                                  ? scoreByFilters(classPeriod, classCriteria)
                                  : "-"}
                              </div>
                            );
                          })}
                        </div>
                      );
                    }
                  )}
                  {/* "Prom." per class (stacked) */}
                  <div
                    style={{
                      ...customStyles.containerAverage,
                      width: widthForCriteria + "px",
                      display: "block",
                    }}
                  >
                    {element.classes.map((singleClass, c_index) => {
                      const classPeriod =
                        (singleClass.periods || [])[p_index] || {};
                      return (
                        <div key={c_index} style={stackedCellStyle(c_index)}>
                          {classPeriod.score}
                        </div>
                      );
                    })}
                  </div>
                  {/* "Prom. CF": single cell vertically merged across classes */}
                  <div
                    style={{
                      ...customStyles.containerAverage,
                      width: widthForCriteria + "px",
                      height: blockHeight + "px",
                      alignItems: "center",
                    }}
                  >
                    {cfAverageByFilters(cfPeriods[p_index], basePeriod.id)}
                  </div>
                  {/* Obse. per class (stacked) */}
                  <div
                    style={{
                      ...customStyles.containerScore,
                      width: widthForCriteria + "px",
                      display: "block",
                      borderRight: "none",
                    }}
                  >
                    {element.classes.map((singleClass, c_index) => {
                      const classPeriod =
                        (singleClass.periods || [])[p_index] || {};
                      return (
                        <div key={c_index} style={stackedCellStyle(c_index)}>
                          <b
                            style={{
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                              overflow: "hidden",
                            }}
                          >
                            <OverlayTrigger
                              trigger="click"
                              placement="top"
                              overlay={popoverComment(classPeriod.comments)}
                              show={
                                visiblePopover.show &&
                                visiblePopover.id === classPeriod.comment_id
                              }
                              onToggle={(value) => {
                                classPeriod.comments
                                  ? handlePopoverClick(
                                      value,
                                      classPeriod.comment_id
                                    )
                                  : null;
                              }}
                              rootClose
                            >
                              <i
                                className="bi bi-info-circle-fill"
                                style={{
                                  color: "#ea2c54",
                                  fontSize: "18px",
                                  opacity: classPeriod.comments ? 1 : 0.5,
                                  cursor: classPeriod.comments
                                    ? "pointer"
                                    : "default",
                                }}
                              />
                            </OverlayTrigger>
                          </b>
                        </div>
                      );
                    })}
                  </div>
                </Row>
              </div>
            );
          })}
        </div>
        {/* "PROM. CLASE" per class */}
        <div
          style={{
            width: "100px",
            height: blockHeight + "px",
            alignItems: "center",
            border: "solid 1px #e9ecef",
            backgroundColor: "#FAFAFA",
            textAlign: "center",
            display: "grid",
            paddingLeft: 0,
          }}
        >
          {element.classes.map((singleClass, c_index) => {
            return (
              <Row
                className="px-0 mx-0"
                key={c_index}
                style={{
                  display: "flex",
                  height: "40px",
                }}
              >
                <div
                  key={c_index}
                  style={{
                    width: "100px",
                    height: "40px",
                    alignItems: "center",
                    border: "solid 1px #e9ecef",
                    backgroundColor: "#FAFAFA",
                    textAlign: "center",
                    display: "grid",
                  }}
                >
                  {singleClass.average}
                </div>
              </Row>
            );
          })}
        </div>
        {/* Final exams per class */}
        {scoreExamForClass(element)}
        {/* "PROM. FINAL" per class */}
        {assessments.hasAssessments && (
          <div
            style={{
              width: "100px",
              height: blockHeight + "px",
              alignItems: "center",
              border: "solid 1px #e9ecef",
              backgroundColor: "#FAFAFA",
              textAlign: "center",
              display: "grid",
              paddingLeft: 0,
            }}
          >
            {element.classes.map((singleClass, c_index) => {
              return (
                <Row
                  className="px-0 mx-0"
                  key={c_index}
                  style={{
                    display: "flex",
                    height: "40px",
                  }}
                >
                  <div
                    key={c_index}
                    style={{
                      width: "100px",
                      height: "40px",
                      alignItems: "center",
                      border: "solid 1px #e9ecef",
                      backgroundColor: "#FAFAFA",
                      textAlign: "center",
                      display: "grid",
                    }}
                  >
                    {singleClass.final_average || "-"}
                  </div>
                </Row>
              );
            })}
          </div>
        )}
        {/* "PROM. DEL CAMPO F." (existing CF total) */}
        <div
          style={{
            width: "100px",
            height: blockHeight + "px",
            alignItems: "center",
            border: "solid 1px #e9ecef",
            backgroundColor: "#FAFAFA",
            textAlign: "center",
            display: "grid",
          }}
        >
          {element.average}
        </div>
      </Row>
    );
  };

  /**
   * Cross-CF "PROMEDIO" row (element `development_area_average`, CM-52604):
   * per period, empty cells under the criteria/"Prom."/"Obse." sub-columns and
   * the CF average (per period or per selected partial) under "Prom. CF".
   * The cycle total renders under the "PROM. DEL CAMPO F." column.
   */
  const developmentAreaAverageRow = (element, index) => {
    const cfPeriods = element.periods || [];
    const fillerCellStyle = {
      width: "100px",
      height: "40px",
      alignItems: "center",
      border: "solid 1px #e9ecef",
      backgroundColor: "#FAFAFA",
      textAlign: "center",
      display: "grid",
    };
    return (
      <Row key={index} style={{ width: "max-content" }}>
        <div
          className="ps-0"
          style={{
            display: "contents",
            height: "40px",
            width: widthForPeriod * periods.length + "px",
          }}
        >
          {periods.map((statePeriod, p_index) => {
            return (
              <div
                key={p_index}
                style={{
                  border: "solid 1px #e9ecef",
                  height: "40px",
                  width: widthForPeriod + "px",
                  maxWidth: widthForPeriod + "px",
                }}
              >
                <Row
                  style={{
                    height: "40px",
                    paddingLeft: "11px",
                    paddingRight: "10px",
                  }}
                >
                  {statePeriod.grading_criteria.map((criteria, cr_index) => {
                    return (
                      <div
                        key={cr_index}
                        style={{
                          ...customStyles.containerScore,
                          width: widthForCriteria + "px",
                          alignItems: "center",
                        }}
                      >
                        <b></b>
                      </div>
                    );
                  })}
                  {/* empty under "Prom." */}
                  <div
                    style={{
                      ...customStyles.containerScore,
                      width: widthForCriteria + "px",
                      alignItems: "center",
                    }}
                  >
                    <b></b>
                  </div>
                  {/* CF averages value under "Prom. CF" */}
                  <div
                    style={{
                      ...customStyles.containerAverage,
                      width: widthForCriteria + "px",
                      alignItems: "center",
                    }}
                  >
                    <b
                      style={{
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                      }}
                    >
                      {cfAverageByFilters(cfPeriods[p_index], statePeriod.id)}
                    </b>
                  </div>
                  {/* empty under Obse. */}
                  <div
                    style={{
                      ...customStyles.containerScore,
                      width: widthForCriteria + "px",
                      alignItems: "center",
                      borderRight: "none",
                    }}
                  >
                    <b></b>
                  </div>
                </Row>
              </div>
            );
          })}
        </div>
        {/* empty under "PROM. CLASE" */}
        <div style={fillerCellStyle}>
          <b></b>
        </div>
        {/* empty under final exams */}
        {assessments.hasAssessments &&
          assessments.assessmentsList.map((assessment, a_index) => {
            return (
              <div key={a_index} style={fillerCellStyle}>
                <b></b>
              </div>
            );
          })}
        {/* empty under "PROM. FINAL" */}
        {assessments.hasAssessments && (
          <div style={fillerCellStyle}>
            <b></b>
          </div>
        )}
        {/* cycle total under "PROM. DEL CAMPO F." */}
        <div style={fillerCellStyle}>
          <b>{element.total_average}</b>
        </div>
      </Row>
    );
  };

  /**
   * General average row under the CF layout (CM-52604): one centered value
   * per period spanning the whole period block, as in the prototype. The
   * fixed columns keep the same cells as the original average row.
   */
  const averageRowWithCFLayout = (element, index) => {
    return (
      <Row key={index} style={{ width: "max-content" }}>
        <div
          className="ps-0"
          style={{
            display: "contents",
            height: "40px",
            width: widthForPeriod * element.periods.length + "px",
          }}
        >
          {element.periods.map((period, p_index) => {
            return (
              <div
                key={p_index}
                style={{
                  border: "solid 1px #e9ecef",
                  height: "40px",
                  width: widthForPeriod + "px",
                  maxWidth: widthForPeriod + "px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <b>{period.score}</b>
              </div>
            );
          })}
        </div>
        <div
          style={{
            width: "100px",
            height: "40px",
            display: "grid",
            alignItems: "center",
            border: "solid 1px #e9ecef",
            backgroundColor: "#FAFAFA",
            textAlign: "center",
          }}
        >
          <b> {element.total_average}</b>
        </div>
        {/* map final exams to keep the fixed columns aligned */}
        {assessments.hasAssessments &&
          element.assessments.map((assessment, a_index) => {
            return (
              <div
                key={a_index}
                style={{
                  width: "100px",
                  height: "40px",
                  display: "grid",
                  alignItems: "center",
                  border: "solid 1px #e9ecef",
                  backgroundColor: "#FAFAFA",
                  textAlign: "center",
                }}
              >
                <b></b>
              </div>
            );
          })}
        {assessments.hasAssessments && (
          <div
            style={{
              width: "100px",
              height: "40px",
              alignItems: "center",
              border: "solid 1px #e9ecef",
              backgroundColor: "#FAFAFA",
              textAlign: "center",
              display: "grid",
            }}
          >
            {element.final_total_average || "-"}
          </div>
        )}
      </Row>
    );
  };

  /* render LazyLoading */
  if (loading) {
    return (
      <Row style={{ padding: "13px" }}>
        <Col
          xxl={12}
          xl={12}
          lg={12}
          xs={12}
          style={customStyles.reportCardBase}
        >
          <div>
            <Row className="table-lazyLoading mt-4">
              <Col xxl={5} xl={5} lg={5} xs={12}>
                <div
                  style={{
                    width: "90px",
                    height: "90px",
                    display: "inline-block",
                  }}
                ></div>
                <div
                  style={{
                    width: "200px",
                    height: "20px",
                    display: "inline-block",
                    bottom: "69px",
                    marginLeft: "20px",
                  }}
                ></div>
              </Col>
              <Col xxl={7} xl={7} lg={7} xs={12} className="float-end">
                <div
                  style={{
                    width: "20%",
                    height: "20px",
                    display: "inline-block",
                    marginLeft: "20px",
                  }}
                ></div>
                <div
                  style={{
                    width: "20%",
                    height: "20px",
                    display: "inline-block",
                    marginLeft: "20px",
                  }}
                ></div>
                <div
                  className="float-end"
                  style={{
                    width: "20%",
                    height: "20px",
                    display: "inline-block",
                    marginLeft: "20px",
                  }}
                ></div>
                <div
                  className="float-end"
                  style={{
                    width: "20%",
                    height: "20px",
                    display: "inline-block",
                    marginLeft: "20px",
                  }}
                ></div>
              </Col>
            </Row>
            <Row className="table-lazyLoading mt-4">
              <Col md={12}>
                <div style={customStyles.lazy}></div>
                <div style={customStyles.lazy} className="mt-4"></div>
                <div style={customStyles.lazy} className="mt-4"></div>
                <div style={customStyles.lazy} className="mt-4"></div>
                <div style={customStyles.lazy} className="mt-4"></div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    );
  }

  /* Render Data */
  if (!loading) {
    return (
      <>
        <Row style={{ padding: "13px" }}>
          <Col
            xxl={12}
            xl={12}
            lg={12}
            xs={12}
            style={
              width <= 767
                ? customStyles.reportCardBaseMovil
                : customStyles.reportCardBase
            }
          >
            {/* Head ReportCard */}
            <Row className="mb-4" style={{ marginLeft: 0, marginRight: 0 }}>
              <Col md={5} sm={12} xs={12} className="ps-0">
                <Row>
                  <div
                    style={{
                      width: width <= 767 ? "30%" : "max-content",
                      display: "inline-block",
                    }}
                  >
                    <img
                      src={reportCardInfo.organization_logo_url}
                      alt="logo"
                      style={{ maxWidth: "90px" }}
                    />
                  </div>

                  <div
                    style={{
                      width: width <= 767 ? "70%" : "max-content",
                      display: "inline-block",
                    }}
                  >
                    <Row>
                      <Col md={12}>
                        <h6>
                          <b>{reportCardInfo.organization_name}</b>
                        </h6>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>{reportCardInfo.student_name}</Col>
                    </Row>
                  </div>
                </Row>
              </Col>
              <Col md={7} xs={12} className="pe-0">
                <Row>
                  <Col md={4} sm={12} xs={12}>
                    <b>
                      {t("reportCards:reportCardBasic.schoolCycle") + " :"}{" "}
                    </b>
                    {reportCardInfo.school_cycle_name}
                  </Col>
                  <Col md={4} xs={6}>
                    <b>{t("reportCards:reportCardBasic.schooling") + " :"} </b>
                    {reportCardInfo.school_level_name}
                  </Col>
                  <Col md={2} xs={3}>
                    <b>{t("reportCards:reportCardBasic.grade") + " :"} </b>
                    {reportCardInfo.grade_level}
                  </Col>
                  <Col
                    md={2}
                    xs={3}
                    className="pe-md-0"
                    style={{ textAlign: "end" }}
                  >
                    <b>{t("reportCards:reportCardBasic.group") + " :"} </b>
                    {reportCardInfo.grade_group}
                  </Col>
                </Row>
              </Col>
            </Row>

            {isLoadingScores && (
              <Row className="center-flex">
                <Spinner animation="border" variant="primary" />
              </Row>
            )}

            {/* Table info */}
            <Row
              className={
                isLoadingScores ? "hidden-container" : "visible-container"
              }
              style={dinamicHeightReport}
            >
              {/* Columna de lateral izquierda - items verticales (classes, develppment area, average) */}
              <div
                style={
                  width <= 767 ? { width: "40%" } : customStyles.columnClasses
                }
              >
                <Row>
                  <div
                    className="align-middle"
                    style={{
                      border: "solid 1px #e9ecef",
                      height: availablePartials
                        ? `${
                            heightForPeriod + (criterias.length > 0 ? 5 : 35)
                          }px`
                        : `${
                            heightForPeriod - (criterias.length > 0 ? 0 : 30)
                          }px`,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {hasDevelopmentAreas &&
                      (width <= 767 ? (
                        <b>
                          {t(
                            "reportCards:reportCardBreakdown.developmentAreas"
                          )}
                        </b>
                      ) : (
                        <div
                          className="text-center"
                          style={{ width: "100%", textTransform: "uppercase" }}
                        >
                          <b>
                            <h6>
                              {t(
                                "reportCards:reportCardBasic.developmentAreas"
                              )}
                            </h6>
                          </b>
                        </div>
                      ))}
                  </div>
                </Row>

                {reportCardInfo.elements.map((element, index) => {
                  return (
                    <Row key={index}>
                      {element.type === "class" && (
                        <>
                          {hasDevelopmentAreas && (
                            <Col
                              md={3}
                              sm={3}
                              xs={3}
                              style={{
                                ...customStyles.verticalText,
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                              }}
                            ></Col>
                          )}
                          <Col
                            md={hasDevelopmentAreas ? 9 : 12}
                            sm={hasDevelopmentAreas ? 9 : 12}
                            xs={hasDevelopmentAreas ? 9 : 12}
                          >
                            <Row>
                              <div
                                className="align-middle text-break"
                                style={{
                                  overflow: "hidden",
                                  "text-overflow": "ellipsis",
                                  alignItems: "center",
                                  border: "1px solid rgb(233, 236, 239)",
                                  textAlign: "center",
                                  height: "40px",
                                  display: "-webkit-box",
                                  WebkitBoxOrient: "vertical",
                                  WebkitLineClamp: 2,
                                }}
                              >
                                {element.name}
                              </div>
                            </Row>
                          </Col>
                        </>
                      )}
                      {element.type === "development_area" && (
                        <>
                          <Col
                            md={3}
                            sm={3}
                            xs={3}
                            style={{
                              ...customStyles.verticalText,
                              maxHeight: 40 * element.classes.length + "px",
                              // whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                              overflow: "hidden",
                            }}
                          >
                            {element.name}
                          </Col>
                          <Col md={9} sm={9} xs={9}>
                            {element.classes.map((singleClass, c_index) => {
                              /* CM-52604: per-class weight shown right-aligned
                                 in the same cell, matching the family report
                                 card. Gated by the FF + switch (showCFWeights);
                                 the type/range check is defensive so an
                                 unexpected or missing backend value fails safe
                                 by not rendering, instead of showing "NaN%" or
                                 an out-of-range value. */
                              const weight = singleClass.cf_weight_percentage;
                              const renderWeight =
                                showCFWeights &&
                                typeof weight === "number" &&
                                weight >= 0 &&
                                weight <= 100;
                              return (
                                <Row key={c_index}>
                                  <div
                                    className="align-middle text-break"
                                    style={{
                                      overflow: "hidden",
                                      "text-overflow": "ellipsis",
                                      alignItems: "center",
                                      border: "1px solid rgb(233, 236, 239)",
                                      textAlign: "center",
                                      height: "40px",
                                      // CM-52583 (QA follow-up): the two-slot
                                      // flex layout only when the weight is
                                      // really rendered; otherwise this cell
                                      // keeps master's line-clamped markup.
                                      ...(renderWeight
                                        ? {
                                            display: "flex",
                                            justifyContent: "space-between",
                                          }
                                        : {
                                            display: "-webkit-box",
                                            WebkitBoxOrient: "vertical",
                                            WebkitLineClamp: 2,
                                          }),
                                    }}
                                  >
                                    {renderWeight ? (
                                      <>
                                        <span
                                          style={{
                                            minWidth: 0,
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            display: "-webkit-box",
                                            WebkitBoxOrient: "vertical",
                                            WebkitLineClamp: 2,
                                          }}
                                        >
                                          {singleClass.name}
                                        </span>
                                        <span
                                          id={
                                            "classWeightValue-breakdown-" +
                                            index +
                                            "-" +
                                            c_index
                                          }
                                          className="text-nowrap flex-shrink-0 ms-2"
                                        >
                                          {weight + "%"}
                                        </span>
                                      </>
                                    ) : (
                                      singleClass.name
                                    )}
                                  </div>
                                </Row>
                              );
                            })}
                          </Col>
                        </>
                      )}
                      {/* CM-52604: label for the cross-CF "PROMEDIO" row.
                          Gated on showCFPeriodAvg ("Promedio Total por
                          Periodos") only — mirrors the family report card, so it hides
                          when that switch is off even if the "Prom. CF" column
                          stays visible via showCFPartialAvg. */}
                      {element.type === "development_area_average" &&
                        showCFPeriodAvg && (
                          <div
                            style={{
                              border: "solid 1px #e9ecef",
                              height: "40px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <b>
                              {t(
                                "reportCards:reportCardBreakdown.cfAveragesRow"
                              )}
                            </b>
                          </div>
                        )}
                      {element.type === "average" && (
                        <div
                          style={{
                            border: "solid 1px #e9ecef",
                            height: "40px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <b>
                            {t(
                              "reportCards:reportCardBreakdown.generalAverage"
                            )}
                          </b>
                        </div>
                      )}
                    </Row>
                  );
                })}
              </div>

              {/* Periodos y calificaciones */}
              {width <= 767 ? (
                // vista movil
                headerPeriodForMovilView()
              ) : (
                // vista escritorio
                <div
                  style={{
                    ...customStyles.columnPeriods,
                  }}
                  id="containerPeriods"
                >
                  {/* periods, partials and criterias */}
                  <Row style={{ width: "max-content" }}>
                    <div
                      className="px-0"
                      style={{
                        height: `${
                          40 +
                          (criterias.length > 0 ? 28 : 0) +
                          (availablePartials ? 30 : 0)
                        }px`,
                        width: widthForPeriod * periods.length + "px",
                        display: "flex",
                      }}
                    >
                      {periods.map((period, index) => {
                        return (
                          <div
                            key={index}
                            style={{
                              width: widthForPeriod + "px",
                              border: "solid 1px #e9ecef",
                              height: `${
                                heightForPeriod -
                                (criterias.length > 0 ? 0 : 30)
                              }px`,
                            }}
                          >
                            {/* Periodo header */}
                            <Row
                              style={{
                                height: "30px",
                                textAlign: "center",
                                alignItems: "center",
                              }}
                            >
                              <b>
                                {t("reportCards:reportCardBasic.period") +
                                  " " +
                                  (index + 1)}
                              </b>
                            </Row>
                            {/* Selector de parciales */}
                            {availablePartials && (
                              <Row
                                style={{
                                  height: "35px",
                                  textAlign: "center",
                                  display: "flex",
                                }}
                              >
                                {/* add dropDown */}
                                {period.grading_criteria[0].partials.length >
                                  0 && (
                                  <Dropdown className="noCaretDd">
                                    <Dropdown.Toggle
                                      id="dropdownReportCards"
                                      variant="outline-secondary"
                                      style={{
                                        textAlign: "start",
                                        width: "150px",
                                      }}
                                    >
                                      {period.selectedPartial &&
                                      period.selectedPartial != "all"
                                        ? t(
                                            "reportCards:reportCardBreakdown.partial"
                                          ) +
                                          " " +
                                          period.selectedPartial.position
                                        : t(
                                            "reportCards:reportCardBreakdown.allPeriods"
                                          )}

                                      <i
                                        className="bi bi-chevron-down float-end"
                                        style={{
                                          marginRight: 0,
                                          marginLeft: "5px",
                                          marginTop: "1px",
                                        }}
                                      />
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu
                                      style={{
                                        textAlign: "start",
                                        width: "150px",
                                        minWidth: "150px",
                                      }}
                                    >
                                      {/* mapear parciales */}
                                      <Dropdown.Item
                                        key={index}
                                        style={{ width: "145px" }}
                                        onClick={() => {
                                          const partial = {
                                            id: "all",
                                          };
                                          handlePartialChange(
                                            period.id,
                                            partial
                                          );
                                        }}
                                      >
                                        {t(
                                          "reportCards:reportCardBreakdown.allPeriods"
                                        )}
                                      </Dropdown.Item>
                                      {period.grading_criteria[0].partials.map(
                                        (partial, indexPartial) => {
                                          return (
                                            <Dropdown.Item
                                              key={indexPartial}
                                              value={partial.id}
                                              style={{ width: "145px" }}
                                              onClick={() => {
                                                partial.position =
                                                  indexPartial + 1;
                                                handlePartialChange(
                                                  period.id,
                                                  partial
                                                );
                                              }}
                                            >
                                              {t(
                                                "reportCards:reportCardBreakdown.partial"
                                              )}{" "}
                                              {indexPartial + 1}
                                            </Dropdown.Item>
                                          );
                                        }
                                      )}
                                    </Dropdown.Menu>
                                  </Dropdown>
                                )}
                              </Row>
                            )}
                            <Row
                              style={{
                                height: "38px",
                                paddingLeft: "11px",
                                paddingRight: "9px",
                              }}
                            >
                              {period.grading_criteria.map(
                                (criteria, index) => {
                                  return (
                                    <div
                                      key={index}
                                      style={{
                                        ...customStyles.containerCriteria,
                                        width: widthForCriteria + "px",
                                      }}
                                    >
                                      <b
                                        style={{
                                          whiteSpace: "nowrap",
                                          textOverflow: "ellipsis",
                                          overflow: "hidden",
                                        }}
                                      >
                                        {criteria.name}
                                      </b>
                                      {criteria.is_averageable == 1 && (
                                        <b>{criteria.percentage + "%"}</b>
                                      )}
                                    </div>
                                  );
                                }
                              )}
                              {/* promedio y comenarios header */}
                              <div
                                style={{
                                  ...customStyles.containerCriteria,
                                  width: widthForCriteria + "px",
                                }}
                              >
                                <b
                                  style={{
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                    overflow: "hidden",
                                  }}
                                >
                                  {t("reportCards:reportCardBasic.average")}
                                </b>
                              </div>
                              {/* CM-52604: "Prom. CF" column header */}
                              {showCFColumn && (
                                <div
                                  style={{
                                    ...customStyles.containerCriteria,
                                    width: widthForCriteria + "px",
                                  }}
                                >
                                  <b
                                    style={{
                                      whiteSpace: "nowrap",
                                      textOverflow: "ellipsis",
                                      overflow: "hidden",
                                    }}
                                  >
                                    {t(
                                      "reportCards:reportCardBreakdown.cfAverage"
                                    )}
                                  </b>
                                </div>
                              )}
                              <div
                                style={{
                                  ...customStyles.containerCriteria,
                                  width: widthForCriteria + 4 + "px",

                                  borderRight: "solid 1px #D6DADB",
                                }}
                              >
                                <b
                                  style={{
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                    overflow: "hidden",
                                  }}
                                >
                                  {t(
                                    "reportCards:reportCardBreakdown.comments"
                                  )}
                                </b>
                              </div>
                            </Row>
                          </div>
                        );
                      })}
                    </div>
                    {/* header promedio campos forativos */}
                    <div
                      style={{
                        border: "solid 1px #e9ecef",
                        height: availablePartials
                          ? heightForPeriod + 5 + "px"
                          : heightForPeriod - 30 + "px",
                        width: "100px",
                      }}
                    >
                      <Row
                        style={{ height: availablePartials ? "65px" : "30px" }}
                      >
                        <b> </b>
                      </Row>
                      <Row
                        style={{
                          height: "38px",
                          textAlign: "center",
                          alignItems: "center",
                          backgroundColor: "#D6DADB",
                          border: "solid 1px #e9ecef",
                        }}
                      >
                        <b>
                          {t("reportCards:reportCardBreakdown.averageClass")}
                        </b>
                      </Row>
                    </div>
                    {/* Mapear header de examenes finales */}
                    {assessments.hasAssessments && assessmentsColumns()}

                    {/* header promedio campos forativos */}
                    {hasDevelopmentAreas && (
                      <div
                        style={{
                          border: "solid 1px #e9ecef",
                          height: availablePartials
                            ? heightForPeriod + 5 + "px"
                            : heightForPeriod - 30 + "px",
                          width: "100px",
                        }}
                      >
                        <Row
                          style={{
                            height: availablePartials ? "65px" : "30px",
                          }}
                        >
                          <b> </b>
                        </Row>
                        <Row
                          style={{
                            height: "38px",
                            textAlign: "center",
                            alignItems: "center",
                            backgroundColor: "#D6DADB",
                            border: "solid 1px #e9ecef",
                          }}
                        >
                          <b>
                            {t(
                              "reportCards:reportCardBreakdown.averageDevelopmentAreas"
                            )}
                          </b>
                        </Row>
                      </div>
                    )}
                  </Row>
                  {/* Iterar elementos de boleta */}
                  {reportCardInfo.elements.map((element, index) => {
                    if (element.type === "class") {
                      const numerOfperiods = element.periods.length;
                      const space = widthForPeriod * numerOfperiods;
                      return (
                        <Row key={index} style={{ width: "max-content" }}>
                          <div
                            className="px-0"
                            style={{
                              display: "flex",
                              height: "40px",
                              width: space + "px",
                            }}
                          >
                            {element.periods.map((period, index) => {
                              return (
                                <div
                                  key={index}
                                  style={{
                                    border: "solid 1px #e9ecef",
                                    height: "40px",
                                    width: widthForPeriod + "px",
                                    maxWidth: widthForPeriod + "px",
                                  }}
                                >
                                  <Row
                                    style={{
                                      height: "40px",
                                      paddingLeft: "11px",
                                      paddingRight: "10px",
                                    }}
                                  >
                                    {period.grading_criteria.map(
                                      (criteria, index) => {
                                        return (
                                          <div
                                            key={index}
                                            style={{
                                              ...customStyles.containerScore,
                                              width: widthForCriteria + "px",
                                              alignItems: "center",
                                            }}
                                          >
                                            {scoreByFilters(period, criteria)}
                                          </div>
                                        );
                                      }
                                    )}

                                    {/* Pomedio y comentarios valores */}
                                    <div
                                      style={{
                                        ...customStyles.containerAverage,
                                        width: widthForCriteria + "px",
                                        alignItems: "center",
                                      }}
                                    >
                                      {period.score}
                                    </div>
                                    {/* CM-52604: filler under "Prom. CF" so
                                    loose classes keep column alignment */}
                                    {showCFColumn && (
                                      <div
                                        style={{
                                          ...customStyles.containerScore,
                                          width: widthForCriteria + "px",
                                          alignItems: "center",
                                        }}
                                      >
                                        <b></b>
                                      </div>
                                    )}
                                    <div
                                      style={{
                                        ...customStyles.containerScore,
                                        width: widthForCriteria + "px",
                                        alignItems: "center",
                                        borderRight: "none",
                                      }}
                                    >
                                      <b
                                        style={{
                                          whiteSpace: "nowrap",
                                          textOverflow: "ellipsis",
                                          overflow: "hidden",
                                        }}
                                      >
                                        <OverlayTrigger
                                          trigger="click"
                                          placement="top"
                                          overlay={popoverComment(
                                            period.comments
                                          )}
                                          show={
                                            visiblePopover.show &&
                                            visiblePopover.id ===
                                              period.comment_id
                                          }
                                          onToggle={(value) => {
                                            period.comments
                                              ? handlePopoverClick(
                                                  value,
                                                  period.comment_id
                                                )
                                              : null;
                                          }}
                                          rootClose
                                        >
                                          <i
                                            className="bi bi-info-circle-fill"
                                            style={{
                                              color: "#ea2c54",
                                              fontSize: "18px",
                                              opacity: period.comments
                                                ? 1
                                                : 0.5,
                                              cursor: period.comments
                                                ? "pointer"
                                                : "default",
                                            }}
                                          />
                                        </OverlayTrigger>
                                      </b>
                                    </div>
                                  </Row>
                                </div>
                              );
                            })}
                          </div>
                          <div
                            style={{
                              width: "100px",
                              height: "40px",
                              alignItems: "center",
                              border: "solid 1px #e9ecef",
                              backgroundColor: "#FAFAFA",
                              textAlign: "center",
                              display: "grid",
                            }}
                          >
                            {element.average}
                          </div>
                          {assessments.hasAssessments &&
                            element.assessments.map((assessment, index) => {
                              return (
                                <div
                                  key={index}
                                  style={{
                                    width: "100px",
                                    height: "40px",
                                    alignItems: "center",
                                    border: "solid 1px #e9ecef",
                                    backgroundColor: "#FAFAFA",
                                    textAlign: "center",
                                    display: "grid",
                                  }}
                                >
                                  {assessment.score || "-"}
                                </div>
                              );
                            })}

                          {assessments.hasAssessments && (
                            <div
                              style={{
                                width: "100px",
                                height: "40px",
                                alignItems: "center",
                                border: "solid 1px #e9ecef",
                                backgroundColor: "#FAFAFA",
                                textAlign: "center",
                                display: "grid",
                              }}
                            >
                              {element.final_average || "-"}
                            </div>
                          )}
                          {hasDevelopmentAreas && (
                            <div
                              style={{
                                width: "100px",
                                height: "40px",
                                alignItems: "center",
                                border: "solid 1px #e9ecef",
                                backgroundColor: "#FAFAFA",
                                textAlign: "center",
                                display: "grid",
                              }}
                            >
                              -
                            </div>
                          )}
                        </Row>
                      );
                    }

                    if (element.type === "development_area") {
                      // CM-52604: with the CF averages active the block is
                      // rendered period-first so the "Prom. CF" cell can
                      // merge vertically across the CF classes.
                      if (showCFColumn) {
                        return developmentAreaRowWithCF(element, index);
                      }
                      const numerOfperiods = element.classes[0].periods.length;
                      const numberOfClasses = element.classes.length;
                      const space = widthForPeriod * numerOfperiods;
                      return (
                        <Row key={index} style={{ width: "max-content" }}>
                          <div
                            className="px-0"
                            style={{
                              height: 40 * numberOfClasses + "px",
                              width: space + "px",
                            }}
                          >
                            {element.classes.map((singleClass, c_index) => {
                              return (
                                <Row
                                  className="px-0 mx-0"
                                  key={c_index}
                                  style={{
                                    display: "flex",
                                    height: "40px",
                                  }}
                                >
                                  {singleClass.periods.map(
                                    (period, p_index) => {
                                      return (
                                        <div
                                          key={p_index}
                                          className="px-0"
                                          style={{
                                            maxWidth: widthForPeriod + "px",
                                            height: "40px",
                                            display: "flex",
                                            alignItems: "center",
                                            borderBottom: "solid 1px #e9ecef",
                                          }}
                                        >
                                          <Row
                                            style={{
                                              height: "40px",
                                              paddingLeft: "12px",
                                              // paddingRight: "10px",
                                              // textAlign: "center",
                                              // display: "grid",
                                            }}
                                          >
                                            {period.grading_criteria.map(
                                              (criteria, index) => {
                                                return (
                                                  <div
                                                    key={index}
                                                    style={{
                                                      ...customStyles.containerScore,
                                                      width:
                                                        widthForCriteria + "px",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    {scoreByFilters(
                                                      period,
                                                      criteria
                                                    )}
                                                  </div>
                                                );
                                              }
                                            )}

                                            {/* Pomedio y comentarios valores */}
                                            <div
                                              style={{
                                                ...customStyles.containerAverage,
                                                width: widthForCriteria + "px",
                                                alignItems: "center",
                                              }}
                                            >
                                              {period.score}
                                            </div>
                                            <div
                                              style={{
                                                ...customStyles.containerScore,
                                                width: widthForCriteria + "px",
                                                alignItems: "center",
                                                borderRight: "none",
                                              }}
                                            >
                                              <b
                                                style={{
                                                  whiteSpace: "nowrap",
                                                  textOverflow: "ellipsis",
                                                  overflow: "hidden",
                                                }}
                                              >
                                                <OverlayTrigger
                                                  trigger="click"
                                                  placement="top"
                                                  overlay={popoverComment(
                                                    period.comments
                                                  )}
                                                  show={
                                                    visiblePopover.show &&
                                                    visiblePopover.id ===
                                                      period.comment_id
                                                  }
                                                  onToggle={(value) => {
                                                    period.comments
                                                      ? handlePopoverClick(
                                                          value,
                                                          period.comment_id
                                                        )
                                                      : null;
                                                  }}
                                                  rootClose
                                                >
                                                  <i
                                                    className="bi bi-info-circle-fill"
                                                    style={{
                                                      color: "#ea2c54",
                                                      fontSize: "18px",
                                                      opacity: period.comments
                                                        ? 1
                                                        : 0.5,
                                                      cursor: period.comments
                                                        ? "pointer"
                                                        : "default",
                                                    }}
                                                  />
                                                </OverlayTrigger>
                                              </b>
                                            </div>
                                          </Row>
                                        </div>
                                      );
                                    }
                                  )}
                                </Row>
                              );
                            })}
                          </div>
                          <div
                            style={{
                              width: "100px",
                              height: 40 * numberOfClasses + "px",
                              alignItems: "center",
                              border: "solid 1px #e9ecef",
                              backgroundColor: "#FAFAFA",
                              textAlign: "center",
                              display: "grid",
                              paddingLeft: 0,
                            }}
                          >
                            {element.classes.map((singleClass, c_index) => {
                              return (
                                <Row
                                  className="px-0 mx-0"
                                  key={c_index}
                                  style={{
                                    display: "flex",
                                    height: "40px",
                                  }}
                                >
                                  <div
                                    key={c_index}
                                    style={{
                                      width: "100px",
                                      height: "40px",
                                      alignItems: "center",
                                      border: "solid 1px #e9ecef",
                                      backgroundColor: "#FAFAFA",
                                      textAlign: "center",
                                      display: "grid",
                                    }}
                                  >
                                    {singleClass.average}
                                  </div>
                                </Row>
                              );
                            })}
                          </div>

                          {/* test */}

                          {scoreExamForClass(element)}
                          {/* test */}

                          {/* Promedio final clase de campo forma */}
                          {assessments.hasAssessments && (
                            <div
                              style={{
                                width: "100px",
                                height: 40 * numberOfClasses + "px",
                                alignItems: "center",
                                border: "solid 1px #e9ecef",
                                backgroundColor: "#FAFAFA",
                                textAlign: "center",
                                display: "grid",
                                paddingLeft: 0,
                              }}
                            >
                              {element.classes.map((singleClass, c_index) => {
                                return (
                                  <Row
                                    className="px-0 mx-0"
                                    key={c_index}
                                    style={{
                                      display: "flex",
                                      height: "40px",
                                    }}
                                  >
                                    <div
                                      key={c_index}
                                      style={{
                                        width: "100px",
                                        height: "40px",
                                        alignItems: "center",
                                        border: "solid 1px #e9ecef",
                                        backgroundColor: "#FAFAFA",
                                        textAlign: "center",
                                        display: "grid",
                                      }}
                                    >
                                      {singleClass.final_average || "-"}
                                    </div>
                                  </Row>
                                );
                              })}
                            </div>
                          )}
                          {/* average formative field */}
                          <div
                            style={{
                              width: "100px",
                              height: 40 * numberOfClasses + "px",
                              alignItems: "center",
                              border: "solid 1px #e9ecef",
                              backgroundColor: "#FAFAFA",
                              textAlign: "center",
                              display: "grid",
                            }}
                          >
                            {element.average}
                          </div>
                        </Row>
                      );
                    }

                    // CM-52604: cross-CF "PROMEDIO" row (values under the
                    // "Prom. CF" column). Gated on showCFPeriodAvg ("Promedio
                    // Total por Periodos") only — mirrors the family report
                    // card, so it hides when that switch is off even if the
                    // "Prom. CF" column stays visible via showCFPartialAvg.
                    if (element.type === "development_area_average") {
                      return showCFPeriodAvg
                        ? developmentAreaAverageRow(element, index)
                        : null;
                    }

                    if (element.type === "average") {
                      // CM-52604: with the CF layout the general average is
                      // one centered value spanning each period block.
                      if (showCFColumn) {
                        return averageRowWithCFLayout(element, index);
                      }
                      return (
                        <Row key={index} style={{ width: "max-content" }}>
                          <div
                            className="ps-0"
                            style={{
                              display: "contents",
                              height: "40px",
                              width:
                                widthForPeriod * element.periods.length + "px",
                            }}
                          >
                            {element.periods.map((period, index) => {
                              return (
                                <div
                                  key={index}
                                  style={{
                                    border: "solid 1px #e9ecef",
                                    height: "40px",
                                    width: widthForPeriod + "px",
                                    maxWidth: widthForPeriod + "px",
                                  }}
                                >
                                  <Row
                                    style={{
                                      height: "40px",
                                      paddingLeft: "11px",
                                      paddingRight: "10px",
                                      // textAlign: "center",
                                      // display: "grid",
                                    }}
                                  >
                                    {period.grading_criteria.map(
                                      (criteria, index) => {
                                        return (
                                          <div
                                            key={index}
                                            style={{
                                              ...customStyles.containerScore,
                                              width: widthForCriteria + "px",
                                              alignItems: "center",
                                            }}
                                          >
                                            <b></b>
                                          </div>
                                        );
                                      }
                                    )}

                                    {/* Pomedio y comentarios valores */}
                                    <div
                                      style={{
                                        ...customStyles.containerAverage,
                                        width: widthForCriteria + "px",
                                        alignItems: "center",
                                      }}
                                    >
                                      <b
                                        style={{
                                          whiteSpace: "nowrap",
                                          textOverflow: "ellipsis",
                                          overflow: "hidden",
                                        }}
                                      >
                                        {period.score}
                                      </b>
                                    </div>
                                    <div
                                      style={{
                                        ...customStyles.containerScore,
                                        width: widthForCriteria + "px",
                                        alignItems: "center",
                                        borderRight: "none",
                                      }}
                                    >
                                      <b
                                        style={{
                                          whiteSpace: "nowrap",
                                          textOverflow: "ellipsis",
                                          overflow: "hidden",
                                        }}
                                      ></b>
                                    </div>
                                  </Row>
                                </div>
                              );
                            })}
                          </div>
                          <div
                            style={{
                              width: "100px",
                              height: "40px",
                              display: "grid",
                              alignItems: "center",
                              border: "solid 1px #e9ecef",
                              backgroundColor: "#FAFAFA",
                              textAlign: "center",
                            }}
                          >
                            <b> {element.total_average}</b>
                          </div>
                          {/* mapear examenes finales para dejar espacios */}
                          {assessments.hasAssessments &&
                            element.assessments.map((assessment, index) => {
                              return (
                                <div
                                  key={index}
                                  style={{
                                    width: "100px",
                                    height: "40px",
                                    display: "grid",
                                    alignItems: "center",
                                    border: "solid 1px #e9ecef",
                                    backgroundColor: "#FAFAFA",
                                    textAlign: "center",
                                  }}
                                >
                                  <b></b>
                                </div>
                              );
                            })}
                          {assessments.hasAssessments && (
                            <div
                              style={{
                                width: "100px",
                                height: "40px",
                                alignItems: "center",
                                border: "solid 1px #e9ecef",
                                backgroundColor: "#FAFAFA",
                                textAlign: "center",
                                display: "grid",
                              }}
                            >
                              {element.final_total_average || "-"}
                            </div>
                          )}
                        </Row>
                      );
                    }
                  })}
                </div>
              )}
            </Row>
          </Col>
        </Row>

        <Modal show={showModalComments} centered>
          <Modal.Header>
            <Modal.Title>
              {/* student name */}
              {reportCardInfo.student_name}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p style={{ textAlign: "justify" }}>{showModalComments}</p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              style={{ width: "100%" }}
              variant="secondary"
              onClick={() => setShowModalComments(false)}
            >
              {t("global:buttons.close")}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
};

export default ReportCardBreakdownComponent;
ReportCardBreakdownComponent.propTypes = {
  studentId: PropTypes.string,
  schoolLevelCycleId: PropTypes.string,
};
